"use client";
import React from 'react';
import { Link } from '@sravni/react-design-system/lib/Typography';
import { useStyles, useAnalytics } from '@sravni/react-utils/lib/hooks';
import { NAMES, HREFS } from '../constants/stores.js';
import modules_c05201b4 from '../styles/Store.module.less.js';

const Store = React.forwardRef((props, ref) => {
    const { store, storeIcon, variant, ...rest } = props;
    const cx = useStyles(modules_c05201b4);
    const { pushEvent } = useAnalytics();
    const handleClick = React.useCallback(() => {
        pushEvent({
            event: 'mainEvent',
            eventCategory: 'Футер',
            eventAction: 'Переход к установке приложения',
            eventLabel: `Футер|${NAMES[store]}`,
        });
    }, [pushEvent, store]);
    return (React.createElement(Link, { ...rest, ref: ref, className: cx('storeButton', { bgDark: variant === 'secondary' }), href: HREFS[store], onClick: handleClick, target: "_blank", rel: "nofollow noopener", "data-store": NAMES[store] }, storeIcon));
});
Store.displayName = 'Store';

export { Store };
//# sourceMappingURL=Store.js.map
